function keyFocus() {
  jQuery("a, input[type=text], .sidebar-filters li h4, .sidebar-filters li ul li input[type=checkbox], .sidebar-filters li.show_more, .sidebar-filters.show_less, .sidebar-filters li label, .sharemenu, .nhr-search-form-submit, header button, #cookie-law-info-bar a, .cli-tab-header a, .cli-modal-close, .video-captions label, .skip-to-content-link").keyboardFocus("is-focused");
}
jQuery(document).ready(function () {
  keyFocus();
});
jQuery(document).ajaxComplete(function () {
  keyFocus();
});


jQuery(function () {
  setTimeout(
    function () {
      // jQuery('.cli-tab-header a').attr('tabindex', '-1');
      // jQuery('#cookie-law-info-bar a').attr('tabindex', '-1');
      // jQuery('.cli-modal-close').attr('tabindex', '-1');

      jQuery('.cli-modal-content a').attr('tabindex', '3');
      jQuery('#cookie-law-info-bar a').attr('tabindex', '3');
      jQuery('.cli-modal-close').attr('tabindex', '3');
      jQuery('.menu-item-has-children ul.sub-menu li a').attr('tabindex', '0');
    }, 200);

 
});




// jQuery('.keyboard-interactions-only').offKeyboardFocus();

// Or, if you have dynamic elements and want to apply your focus class to all
// elements that match a given selector:
// jQuery.keyboardFocus({ a: "is-focused"
// You can specify multiple class name mappings.
// });

// And, similarly, to remove keyboard focus handlers:
// jQuery.offKeyboardFocus();